export const pagesText = {
  register: {
    title: 'Get started, register below',
    subtitle: 'Enter details for account information',
    question: 'Already have an account?',
    questionLinkText: 'Login',
    registerButton: 'Register',
    termsAndConditions: {
      agree: 'By registering, I agree to App Control',
      termsOfService: 'Terms of Service',
      and: 'and',
      privacyPolicy: 'Privacy Policy',
    },
  },
  login: {
    acceptInvitationTitle: 'To accept the invitation logon to your account',
    title: 'Sign In',
    question: 'Forgot password?',
    getStarted: {
      question: 'Don’t have an account?',
      linkText: 'Get started',
    },
    loginButton: 'Login',
  },
  verifyEmail: {
    title: 'Verify Your Email to Login',
    subtitle:
      'To finish registration, please verify your account by clicking the link sent to your email.',
    additionalInfo: 'Check your email and follow the instructions',
    resendButton: 'Resend verification email',
    loginButton: 'Back to login',
  },
  resetPassword: {
    title: 'Reset Password',
    resetButton: 'Reset Password',
  },
  dashboard: {
    title: 'All Apps',
    name: 'App Import Catalog',
    breadcrumbs: {
      pageName: 'App Import Catalog',
    },
    headings: {
      softwareCenterName: 'Public Application Name',
      publisher: 'Publisher',
      versionsCount: 'Total Versions',
      latestVersion: 'Latest Version',
      version: 'Version',
      totalInstalls: 'Total Installs',
      installSize: 'Install Size',
      configManagerName: 'Internal Application Name',
      timestamp: 'Date added',
    },
  },
  WDACResults: {
    editDataModal: {
      title: 'Edit Status & Note',
      tooltipText:
        'Marking an application as trusted or untrusted is used to filter the application list. These actions do not alter the policy on devices within your organization in any way. Making sure a trusted application is allowed to run on an enforced device will require additional actions beyond marking the application as trusted in this interface. ',
    },
  },
  packagedApps: {
    editDataModal: {
      title: 'Edit Status & Note',
      tooltipText:
        'Marking a packaged app as trusted or untrusted will result in packaged apps being added or removed from the supplemental policy that can be generated. Once deployed, trusted apps will be allowed to run on end users devices. ',
    },
  },
  breadcrumbTitle: 'App Control',
  appsDetails: {
    headings: {
      applicationName: 'Application Name',
      blockedByDynamicCodeSecurity: 'Dynamic Code Security',
      trustedByISG: 'Trusted by ISG',
      totalFiles: 'Total files',
    },
    generalSection: {
      title: 'General',
    },
  },
  appsStarterPopup: {
    title: 'Welcome to App Control',
    description:
      'To get started with App Control it needs to collect some details from your Microsoft Endpoint Configuration Manager. Please download the binary below to setup the connection between your environment and App Control.',
    extraDescription:
      'For more details around the process and the prerequisites that need to be in place, please visit our Documentation page',
  },
  forgotPassword: {
    title: 'Forgot your password?',
    subtitle: 'Enter your email address below and we’ll send you a reset link',
    submitButton: 'Send Reset Email',
    backLogin: 'Back to login',
  },
  userProfileMenu: {
    settings: 'Settings',
    changeOrganization: 'Change environment',
    logout: 'Logout',
  },
  supportTicketDialog: {
    title: 'Submit a support ticket',
    subjectLabel: 'Subject',
    subjectPlaceholder: 'Short summary of the issue',
    descriptionLabel: 'Description',
    descriptionPlaceholder: "What's affected, what happened and when it started",
    companyLabel: 'Company',
    environmentLabel: 'Environment',
    submitButton: 'Submit',
    cancelButton: 'Cancel',
    closeButton: 'Close',
    successMessage: 'Support ticket submitted successfully',
    submittedTitle: "We've received your ticket",
    submittedMessage: 'Support will be in touch with you shortly.',
    validation: {
      subjectRequired: 'Subject is required',
      descriptionRequired: 'Description is required',
      subjectMax: 'Subject must be 200 characters or fewer',
      descriptionMax: 'Description must be 4000 characters or fewer',
    },
  },
  tableExpandedRowActions: {
    info: 'Information',
    security: 'Security',
    license: 'License',
    actions: 'Actions',
  },
  securityExpandedRowActions: {
    securityCatalog: 'Security Catalog',
    securityPolicyWithFallback: `WDAC Policy`,
    securityPolicyWithoutFallback: `WDAC Policy (without FallBack)`,
    all: 'All',
  },
  tableAllVersionsButton: 'See All Versions',
  environments: {
    validationMessages: {
      configManager: {
        required: 'Support ID is required',
        length: 'Support ID must be 44 characters',
      },
      intune: {
        required: 'Azure Tenant ID is required',
        length: 'Azure Tenant ID must be 36 characters',
        guid: 'Azure Tenant ID must be a valid GUID',
      },
      other: {
        required: 'Environment id is required',
        length: 'Custom id must be 36 characters',
        guid: 'Custom ID must be a valid GUID',
      },
    },
    applicationManagementLabel: 'Application Management solutions',
    applicationManagementPlaceholder: 'Select Application Management solution',
    title: 'Environments',
    addButton: 'Add New Environment',
    editButton: 'Edit',
    supportIdInfoText: `You can copy/paste your Support ID from the About Configuration Manager dialog box. You can open this dialog box from any Configuration Manager Admin UI by opening the menu on the top left of the UI.`,
    intuneInfoText: 'Where can I find my Azure Tenant ID ?',
    intuneInfoLinkText: 'How to find your tenant ID - Microsoft Entra | Microsoft Learn',
    environmentsTable: {
      headings: {
        environmentName: 'Environment Name',
        description: 'Description',
        actions: 'Actions',
      },
      action: {
        select: 'Select',
        selected: 'Selected',
        edit: 'Edit',
        delete: 'Delete',
      },
    },
    formDialog: {
      addTitle: 'Add New Environment',
      editTitle: 'Edit Environment',
    },
    deviceLoggingApiKey: {
      regenerateSuccess: 'Device Logging API Key has been regenerated successfully',
    },
    envIdMenu: {
      configurationManager: 'Configuration manager',
      intune: 'Intune',
      other: 'Other management solution',
    },
    confirmTenantId: {
      intune: {
        title: 'Confirm ID',
        buttonText: 'Yes',
        infoMessage: 'If you confirm, the Tenant ID will be saved and cannot be changed later.',
      },
      configManager: {
        title: 'Confirm ID',
        buttonText: 'Yes',
        infoMessage: 'If you confirm, the Support ID will be saved and cannot be changed later.',
      },
    },
  },
  environment: {
    title: 'Environment',
    summary: {
      title: 'Summary',
    },
    policies: {
      title: 'WDAC Policies',
    },
    detailsCard: {
      title: 'Environment Details',
      editButton: 'Edit',
      deviceLoggingKey: 'Device Logging Key',
    },
  },
  authLabels: {
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    password: 'Password',
    repeatPassword: 'Confirm password',
    companyName: 'Company name',
  },
  userProfileEditMessage: 'Your profile has been updated successfully',
  mfaLabels: {
    enable: 'Enable Multi-Factor Authentication',
    disable: 'Disable Multi-Factor Authentication',
    currentPassword: 'Current Password',
    sharedKey: 'Shared Key',
    authenticatorURI: 'Authenticator URI',
    authenticatorCode: 'Authenticator Code',
  },
  mfaDetails: {
    title: 'Multi-Factor Authentication',
    disabledSuccess: 'Multi-factor authentication disabled',
  },
  mfaSetup: {
    title: 'Multi-Factor Authentication',
    about: `Keep your account safe with an extra layer of protection. Multi-factor authentication adds a second step to
       your login so even if your password is stolen, your account stays secure.`,
    passwordInstructions: 'Enter your password to continue setting up Multi-Factor Authentication.',
    passwordVerified: 'Password verified',
    mfaGenerationFail: 'Failed to generate data for multi-factor setup',
    verifyFailed: 'Verification failed',
    verifyButton: 'Verify',
    noData: 'No setup data available.',
  },
  mfaConfimation: {
    title: 'MFA Setup Instructions',
    description:
      'Secure your account with an extra layer of protection. Multi-factor authentication helps keep your account safe even if your password is compromised.',
    stepOne: `1) Use an authenticator app (Google Authenticator, Authy, etc.) to add a new account. You
        can scan the QR code below or manually enter the shared key.`,
    stepTwo: `2) After adding the account, your app will show a 6-digit code — enter it below to verify
        and enable MFA.`,
    authenticatorInstruction: 'Enter code from your authenticator app',
    enabled: 'MFA enabled',
    error: 'Verification failed',
  },
  mfaPrompt: {
    title: 'Enable Multi-Factor Authentication?',
    description:
      'Add an extra layer of security to your account. Multi-factor authentication helps protect your account even if your password is compromised.',
    enableButton: 'Enable MFA',
    skipButton: 'Skip for now',
  },
  mfaForm: {
    title: 'Multi-Factor Authentication',
    instruction: 'Enter the 6-digit code from your authenticator app to continue.',
    success: 'Multi-factor authentication verified',
    tokenError: 'No token received for completing multi-factor sign-on',
    codeError: 'Invalid code',
    cancelButton: 'Cancel',
    verifyButton: 'Verify',
  },
  noEnvironmentAlert: {
    title: 'No Linked Environment and/or no selected environments',
    descriptionFirstPart: `Oops! It seems like there are no environments and/or no selected environments currently associated with your account. To get
      started, please create a new environment using a valid support ID and take the next step to
      configure your server. If you need any assistance, our support team is here to help! Open this`,
    descriptionSecondPart: 'to create a new environment',
    descriptionLinkText: 'link',
  },
  passwordValidationFields: {
    min: 'At least 15 characters long.',
  },
  deleteEnvironmentButton: 'Delete Environment',
  deleteEnvironment: {
    title: 'Are You Sure You Want to Delete This Environment?',
    description: `Application Catalog has been created. Deleting the environment cannot be undone and your
        application catalog data will be deleted.`,
    cancelButton: 'Go Back',
    confirmButton: 'Yes, Delete',
  },
  switchEnvironmentDialog: {
    descriptionPartOne: 'You are about to switch to Environment',
    descriptionPartTwo: 'Would you like to continue?',
    cancelButton: 'Go Back',
    confirmButton: 'Yes',
  },
  filters: {
    sorting: {
      title: 'Sort',
      ascending: 'Ascending',
      descending: 'Descending',
    },
    filter: {
      title: 'Filter',
      contain: 'Contains',
      notContain: 'Does Not Contain',
      executed: 'Execution',
      installed: 'Installation',
      yes: 'Yes',
      no: 'No',
    },
    addConditionButton: 'Add Condition',
    applyFiltersButton: 'Apply Filter',
    saveFiltersButton: 'Show results',
    addFilterButton: 'Add',
    removeFilterButton: 'Remove',
    resetFiltersButton: 'Reset',
    totalNumber: 'Total Number',
    blockedByDynamicCodeSecurity: 'Blocked by dynamic code security',
    trustedByISG: 'Trusted by The Intelligent Security Graph',
    dateFilter: 'Date Filter',
  },
  totalNumberVersions: 'Total number of app versions',
  cancelButton: 'Cancel',
  sidebarNavigation: {
    apps: 'Apps',
    license: 'License',
    actions: 'Actions',
    devices: 'Devices',
    WDACResults: 'WDAC Results',
    dashboard: 'Dashboard',
    environment: 'Environment',
  },
  downloadsNavigation: {
    serverAgent: 'Managed apps processor',
    clientAgent: 'Endpoint client',
    managedInstaller: 'Managed installer configurator',
  },
  supportNavigation: {
    knowledgeBase: 'Knowledge base',
    faq: 'Check our FAQ',
    whatsNew: "What's new",
    submitTicket: 'Submit a ticket',
  },
  error: {
    title: 'Page Not Found',
    description:
      "The page you requested may have been moved, deleted, or you may have the wrong URL. Let's get you back on track.",
    button: 'Back to Home',
    errorText: '404',
  },
  passwordHintTitle: 'Password must have',
  noSearchResult: 'No results found',
  notifications: {
    startDownload: 'File is getting prepared in the background.',
    readyToDownload: 'File is ready to download',
    downloadFailed: 'File download failed',
    markAllAsRead: 'The notifications have been successfully marked as read.',
  },
  bulkDownloadPage: {
    bulkDownload: 'Bulk Download',
    bulkDownloadOptionsButton: 'Create New Bulk Download',
    breadcrumbs: {
      pageName: 'Bulk Download',
    },
    noResult: {
      title: 'No Bulk Files Found',
      description: `Oops! It looks like there are no bulk files currently available. Don't worry, you can easily download bulk files by selecting the corresponding download option. Once downloaded, you'll find the status and history of your bulk files in the Bulk File History section. Get started now to manage your data more efficiently!`,
    },
    securityDownloadDialog: {
      title: 'Choose file type for bulk download',
      dateTitle: 'Select interval for chosen file type',
    },
  },
  companyDetails: {
    placeholder: 'Enter Company Name',
    editCompanySnackbarText: 'Customer name updated successfully',
    createCompanySnackbarText: 'Company created successfully',
    update: {
      title: 'Edit company details',
    },
    create: {
      title: 'Create company',
    },
  },
  companyMembers: {
    successfullyUpdateUserStatus: 'User status has been updated successfully',
  },
  companyUsers: {
    title: 'Company Users',
    headings: {
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      status: 'Status',
    },
    disableMfaButton: 'Disable MFA',
  },
  inviteUsers: {
    title: 'Invite Users',
    headings: {
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      status: 'Status',
    },
    validationMessages: {
      firstName: 'First name is required',
      lastName: 'Last name is required',
      email: 'Email is required',
    },
    inputFields: {
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
    },
    resendInvitesButton: 'Resend Invites',
    invitesButton: 'Invite User',
    addCustomerSnackbar: 'Invite has been sent successfully',
  },
  downloadButton: 'Download',
  noVersionFound: 'No version found',
  noDataFound: 'No data found',
  somethingWentWrong: 'Oops something went wrong, please try again later',
  yesCell: 'Yes',
  noCell: 'No',
  companyList: {
    title: 'Companies',
    searchPlaceholder: 'Enter company name',
    createCompany: 'Create a new Company',
    noResult: 'No companies found',
    headings: {
      companyName: 'Company Name',
    },
    noCompanyAlert: {
      title: 'No Access',
      description:
        'You do not have permission to access any active customers. Please contact your administrator if you believe this is a mistake.',
    },
  },
  setupAccount: {
    title: 'To accept the invitation setup your user account',
    button: 'Accept Invitation',
  },
  failedToAcceptInvitation:
    'The invite is for another user with a different email address - to accept the invite logon with the correct email address',
  emailInvitationPage: {
    title: {
      setupAccount: 'To accept the invitation setup your user account',
      acceptInvitation: 'To accept the invitation logon to your account',
    },
    buttonText: {
      setupAccount: 'Setup Account',
      acceptInvitation: 'Login',
    },
  },
  emailValidationErrorMessage: 'Email must be a valid email address',
  selectCompany: 'Select company',
  emailValidationPopup: {
    title: 'Oops',
    description: `The link to your invitation has expired or is not valid. Please contact your referrer
            for a re-invite`,
  },
  deviceApiKeyDialog: {
    title: 'Device Logging API Key',
    helpText: 'To use our device logging agent see the ',
    helpLinkText: 'knowledge base',
    closeButton: 'Close',
    regenerateButton: 'Regenerate',
    generateButton: 'Generate',
    copy: 'Copy',
    regenerateTextMessage: `You can regenerate the key, however if you do ALL existing agents 
using this key will stop functioning until you update them with a new key`,
    noKeyFound: "No API key Present. Click 'Generate' to create one",
  },
  confirmDeviceKeyRegeneration: {
    title: 'Are you sure you want to regenerate the Device Logging API Key?',
    description: `If you regenerate the key, all existing agents using this key will stop functioning until you update them with a new key`,
    confirmActionMessage: 'Type "I CONFIRM" to confirm the action',
    cancelButton: 'Cancel',
    confirmButton: 'Yes, Regenerate',
  },
  devices: {
    title: 'Devices',
    breadcrumbs: {
      pageName: 'Devices',
    },
    headings: {
      name: 'Device',
      tagName: 'Device Tags',
      lastContactDate: 'Last Contact Date',
      status: 'Status',
      wdacStatus: 'WDAC Status',
      osVersion: 'OS Version',
      osSku: 'OS SKU',
      osType: 'OS Type',
      logCollectorVersion: 'Log collector version',
    },
    filterChartTitle: 'Filters',
    editTagModal: {
      title: 'Edit Device Tags',
      onCloseButton: 'Close',
      removeTagMessage: 'Device Tags removed successfully',
    },
    successFullyUpdateDeviceStatus: 'Device status has been updated successfully',
    successFullyUpdateDeviceTag: 'Device tag has been updated successfully',
    newTagPlaceholder: 'Click Add button to add new device tag',
    totalDevices: 'Total Devices',
    chartDatePicker: {
      options: {
        last5Days: 'Last 5 days',
        last10Days: 'Last 10 days',
        last30Days: 'Last 30 days',
      },
    },
  },
  deviceDetails: {
    generalSection: {
      name: 'Name',
      uniqueExternalId: 'Unique_External_id',
      status: 'Status',
      deviceCustomerEnvironmentTag: 'Device Tags',
      osSku: 'SKU',
      osType: 'OSType',
      osVersion: 'OSVersion',
      logCollectorVersion: 'LogCollector version',
      createdAt: 'Created Date',
      updatedAt: 'Updated Date',
      lastContactDate: 'Last Contact Date',
      lastWdacHeartbeatDate: 'WDAC Last Heartbeat Date',
      wdacStatus: 'WDAC Status',
    },
  },
  execution: 'Execution',
  installation: 'Installation',
  deviceDashboard: {
    totalDeviceInEnvironment: 'Device Enforcement State',
    devicesOnline: 'Client Health',
    // devicesOnlineFrom: 'Client Health Status received from x days',
    policyTitle: 'Policy distribution',
    managedInstallerTitle: 'Managed Installer Distribution',
    versionLogCollectorTitle: 'Client Agent versions',
  },
  deleteTagDialog: {
    title: 'Are you sure you want to delete the device tag ?',
    yes: 'Yes',
    no: 'No',
    description: 'The device tag will be deleted from the device tag list as well as removed from',
  },
  copyTextMessage: 'Copied to clipboard',
  securityDownloadSteps: {
    downloadDateStep: {
      all: 'All files',
      custom: 'Custom range',
      since: 'Since',
    },
    noDateRangeAlert: 'Please select date range',
  },
  next: 'Next',
};
